import { ROLES } from '@/constants';
import {
  AUTH_ERROR,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  SET_USER_ID,
  SET_USERNAME,
  USER_ERROR,
  USER_REQUEST,
  USER_SUCCESS,
  LOGOUT_SUCCESS,
  CONFIRM_EMAIL_ERROR,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_LOADING,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_LOADING,
  FORGOT_PASSWORD_ERROR,
  POST_NEW_PASSWORD_ERROR,
  POST_NEW_PASSWORD_SUCCESS,
  POST_NEW_PASSWORD_LOADING,
  SET_USER_ROLES,
  SET_CPA_ID,
} from '@/app/auth/store/types';

export const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.authStatus = 'loading';
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.authStatus = 'success';
    state.authToken = resp.data.accessToken;
    state.refreshToken = resp.data.refreshToken;
  },
  [AUTH_ERROR]: (state) => {
    state.authStatus = 'error';
    state.authToken = '';
  },
  [USER_REQUEST]: (state) => {
    state.userStatus = 'loading';
  },
  [USER_SUCCESS]: (state, resp) => {
    state.userStatus = 'success';
    state.userProfile = resp;
  },
  [USER_ERROR]: (state) => {
    state.userStatus = 'error';
  },
  [SET_USERNAME]: (state, username) => {
    state.username = username;
  },
  [SET_USER_ID]: (state, userId) => {
    state.userId = userId;
  },
  [LOGOUT_SUCCESS]: (state) => {
    state.authStatus = '';
    state.authToken = '';
    state.refreshToken = '';
  },
  [CONFIRM_EMAIL_SUCCESS]: (state) => {
    state.confirmEmailLoadingStatus = 'success';
  },
  [CONFIRM_EMAIL_LOADING]: (state) => {
    state.confirmEmailLoadingStatus = 'loading';
  },
  [CONFIRM_EMAIL_ERROR]: (state) => {
    state.confirmEmailLoadingStatus = 'error';
  },
  [FORGOT_PASSWORD_LOADING]: (state) => {
    state.forgotPasswordStatus = 'loading';
  },
  [FORGOT_PASSWORD_SUCCESS]: (state) => {
    state.forgotPasswordStatus = 'success';
  },
  [FORGOT_PASSWORD_ERROR]: (state) => {
    state.forgotPasswordStatus = 'error';
  },
  [POST_NEW_PASSWORD_LOADING]: (state) => {
    state.newPasswordStatus = 'loading';
  },
  [POST_NEW_PASSWORD_SUCCESS]: (state) => {
    state.newPasswordStatus = 'success';
  },
  [POST_NEW_PASSWORD_ERROR]: (state) => {
    state.newPasswordStatus = 'error';
  },
  [SET_USER_ROLES]: (state, roles) => {
    state.userRoles = roles;
    state.isCPA = roles.includes(ROLES.CPA)
    || roles.includes(ROLES.ADMIN)
    || roles.includes(ROLES.SUPER_ADMIN);
    state.CPAId = null;
  },
  [SET_CPA_ID]: (state, id) => {
    state.CPAId = id;
  },
};
